export default __webpack_public_path__ + "static/media/Icon_FreeTextChoice.dcc3c9da.svg";